var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVproduct(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1111 21V12.6502L4 8.42966V15.7529C4 16.0875 4.07778 16.3916 4.23333 16.6654C4.38889 16.9392 4.60741 17.1597 4.88889 17.327L11.1111 21ZM12.8889 21L19.1111 17.327C19.3926 17.1597 19.6111 16.9392 19.7667 16.6654C19.9222 16.3916 20 16.0875 20 15.7529V8.42966L12.8889 12.6502V21ZM16.4222 8.45247L19.0444 6.87833L12.8889 3.25095C12.6074 3.08365 12.3111 3 12 3C11.6889 3 11.3926 3.08365 11.1111 3.25095L9.35556 4.27757L16.4222 8.45247ZM12 11.076L14.6444 9.52471L7.6 5.327L4.93333 6.90114L12 11.076Z",
    fill: "#E3E3E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVproduct);
export default __webpack_public_path__ + "static/media/vproduct.45b12217d25a6f26aeeb8396dfea3645.svg";
export { ForwardRef as ReactComponent };